// extracted by mini-css-extract-plugin
export default {"rating":"eD-z","numberOfStars":"fD-z","count":"gD-z","barGraphSpacing":"hD-z","barGraph":"iD-z"};